import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// ============ INTERFACE ============

export interface FormStateInterface {
  customer: {
    dateOfBirth?: string;
    age?: number;
  }
}

// ============ INIT STATE ============

const initialState: FormStateInterface = {
  customer: {}
};

// ========= SLICE ==========

export const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setCustomerDataOld: (state: FormStateInterface, action: PayloadAction<{dateOfBirth?: string, age?: number}>) => {
      state.customer = {
        ...state.customer,
        ...action.payload
      };
    },
  }
})

export const { setCustomerDataOld } = formSlice.actions;

export default formSlice.reducer;